import React from 'react';
import { get, isUndefined } from 'lodash';
/**
 * FormSelect
 * options accept array of object with below parameters
 *  ex:
 *   - [{id: "", name: "" },...],
 *   - [{value: "", label:""},...],
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FormSelectInTable = (props) => {

    const {
        id, label, value, options, className, onChange, errors, register, disabled, isControlled = false,
    } = props;

    return (
        <td>
            { label && <label htmlFor={id}>{label}</label>}
            <select
                id={id}
                name={id}
                className={`form-control ${className}`}
                {...(isControlled ? {value: value} : {defaultValue: value})}
                onChange={onChange}
                ref={register}
                disabled={disabled}
            >
                <option value=''>- Select -</option>
                {options.map((item, i) =>
                    <option
                        key={i}
                        value={ isUndefined(item.id) ? item.value : item.id }
                    >
                        { isUndefined(item.name) ? item.label : item.name }
                    </option>
                )}
            </select>
            {errors && <span>{ get(errors, id)?.message }</span>}
        </td>
    );
}

export default React.memo(FormSelectInTable);
